import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link, useStaticQuery, graphql } from "gatsby";
import { useSpring, animated } from "react-spring";
import _ from "lodash";

const kebabCase = (string) => {
	return string
		.replace(/\s+/g, "-")
		.toLowerCase()
		.replace(/[^a-zA-Z0-9-_]/g, "");
};

/* Lineup Card
============================================================================= */

const calc = (x, y, width, height) => [
	-(y - height / 2) / 15,
	(x - width / 2) / 15,
	1.25,
];
function relativeCoords(event) {
	var bounds = event.target.getBoundingClientRect();
	var x = event.clientX - bounds.left;
	var y = event.clientY - bounds.top;
	return { x: x, y: y, width: bounds.width, height: bounds.height };
}
const trans = (x, y, s) =>
	`perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`;

const LineupCard = ({ name = "PARKWAY DRIVE", fluid }) => {
	const [props, set] = useSpring(() => ({
		xys: [0, 0, 1],
		config: { mass: 5, tension: 350, friction: 40 },
	}));
	return (
		<Link to={`/artists/${kebabCase(name)}`}>
			<div className="card-container">
				<animated.div
					className="artist-card"
					onMouseMove={(e) => {
						const { x, y, width, height } = relativeCoords(e);
						set({ xys: calc(x, y, width, height) });
					}}
					onMouseLeave={() => set({ xys: [0, 0, 1] })}
					style={{ transform: props.xys.interpolate(trans) }}
				>
					<GatsbyImage
						className="artist-card-image"
						objectFit="cover"
						objectPosition="50% 50%"
						alt={name}
						image={fluid}
					/>
					<div className="artist-card-hover-overlay translate-y-6">
						<div className="artist-item-name-overlay">
							<h2 className="artist-name">{name}</h2>
						</div>
					</div>
				</animated.div>
			</div>
		</Link>
	);
};

/* Export
============================================================================= */

export default LineupCard;
